export const deduSites = [
  {
    id: 1286,
    name: 'Core Hospitals of America',
    host: 'core-hospitals-of-america',
    status: 'enabled',
    language: 'en',
    time_zone: 'Casablanca',
    use_custom_host: true,
    custom_host: 'learning-bbb-staging.myevolve.health',
    created_at: '2020-03-10T17:30:05.000+01:00',
    updated_at: '2021-04-26T18:46:15.000+00:00',
  },
];
